import React, { useState, useEffect } from "react";

const isSelected = (selectedList, newSelectedItem) =>
  selectedList.some(
    (selectedItem) =>
      selectedItem.id === newSelectedItem.id && selectedItem.type === newSelectedItem.type
  );

const AccordionItem = ({
  item: { items = [] } = {},
  item,
  disabled,
  handleCheckboxChange,
  selectedItems = []
}) => {
  const checkedChildren = items.filter((child) => isSelected(selectedItems, child));
  const [isOpen, setIsOpen] = useState(false);

  const checked = isSelected(selectedItems, item);

  useEffect(() => {
    if (checkedChildren.length) {
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    if (selectedItems.length === 0) {
      setIsOpen(false);
    }
  }, [selectedItems]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const isDisabled = disabled && !checked;

  const accordionHeaderDisabledClass = isDisabled
    ? checkedChildren.length
      ? "checked-child"
      : "disabled"
    : "";

  return (
    <li className={`accordion-item${isOpen ? " open" : ""}`}>
      <div className={`accordion-item-header ${accordionHeaderDisabledClass}`}>
        <input
          className="checkbox"
          type="checkbox"
          id={item.id}
          checked={checked}
          onChange={() => handleCheckboxChange(item, checked)}
          disabled={isDisabled}
        />

        <label htmlFor={item.id} className="accordion-label">
          {item.name}
        </label>

        {items.length >= 1 && <button className="accordion-toggle" onClick={toggleOpen} />}

        {checkedChildren.length >= 1 && (
          <span className="selected-label">(Selected options: {checkedChildren.length})</span>
        )}
      </div>

      {items && isOpen && (
        <ul className="accordion-list">
          {items.map((child) => (
            <AccordionItem
              key={child.id}
              item={child}
              handleCheckboxChange={handleCheckboxChange}
              selectedItems={selectedItems}
              disabled={disabled}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default AccordionItem;
